import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const EmpresaList = props => <DefaultDataTable data={props} />;
